import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { FacebookLoginButton } from '@stepstone/social-auth-components';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.js';
import { isFacebookEnabledSelector } from '../../../../redux/core/siteConfig/siteConfigSlice.js';
import { setErrorStatus, setShowRegistrationSuccessfulModal, } from '../../registrationSlice.js';
import { callbackFunctionSelector, redirectionUrlSelector, } from '../../../../redux/core/sourceData/sourceDataSlice.js';
import { saveCandidateJustLoggedInCookie } from '../../../../helpers/storage/cookies.js';
import { executeCallbackFunction } from '../../../../helpers/callback.js';
import { redirect } from '../../../../helpers/url/url.js';
import { useSendFacebookTrackingScript } from '../../../../tracking/featureSpecific/facebook/index.js';
import { INITIAL_TRACKING_DELAY } from '../../../../tracking/constants.js';
import { dispatchLoginSuccessEvent } from '../../../../helpers/dispatchLoginSuccessEvent.js';
export const RegistrationWithFacebook = () => {
    const isFacebookEnable = useAppSelector(isFacebookEnabledSelector);
    const onLoginSuccess = useAppSelector(callbackFunctionSelector);
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const handleFacebookLoginError = () => {
        dispatch(setErrorStatus(401));
    };
    const handleFacebookLoginSuccess = async ({ accountWasCreated, }) => {
        if (accountWasCreated) {
            setTimeout(() => {
                dispatch(setShowRegistrationSuccessfulModal(true));
            }, INITIAL_TRACKING_DELAY);
        }
        else {
            saveCandidateJustLoggedInCookie();
            dispatchLoginSuccessEvent();
            await executeCallbackFunction(onLoginSuccess);
            redirect(redirectionUrl);
        }
    };
    const { setTrackingEventState } = useSendFacebookTrackingScript('registration');
    return isFacebookEnable ? (_jsx(FacebookLoginButton, { a11yLabel: t('loginregistration.registration.facebookButton'), buttonText: t('loginregistration.registration.facebookButton'), onSuccess: handleFacebookLoginSuccess, onError: handleFacebookLoginError, onSendTrackingCallback: setTrackingEventState })) : null;
};
//# sourceMappingURL=RegistrationWithFacebook.js.map